import { useEffect } from 'react';
import { getSimpleLocation, redirectAfterAuth } from '@helloworld1812/ws-router';
import { wsSessionStorage } from '@helloworld1812/ws-storage';

import BroadcastChannel from '@/utils/broadcast-channel';

/* TODO: Move logic about broadcast channel about multi tab login detection together in ws-auth */
function MultitabDetector() {
  useEffect(
    () => {
      const tabId = wsSessionStorage.getTabId();
      const bc = BroadcastChannel('multi-login-detector');
      bc.onmessage = (event) => {
        const data = event.data as { tabId: string; type: string };
        if (data.tabId === tabId) {
          return;
        }

        const location = getSimpleLocation();

        if (['/login', '/select-company'].includes(location.pathname)) {
          redirectAfterAuth();
        }
        window.location.reload();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return null;
}

export default MultitabDetector;
